import i18next from "i18next";

import { Models } from "../../api/types";

export type AdonisRecommendationModel = Models<"AdonisRecommendationModel">;
export type AdonisRecommendationModelBaseCommandResult =
  Models<"AdonisRecommendationModelBaseCommandResult">;

export const AdonisCTAType = {
  Variation1: "variation1",
  Variation2: "variation2",
  Variation3: "variation3",
} as const;

export interface AdonisSession {
  id: string;
  expiresAt: number;
}

export type AdonisIdentity = {
  name: string;
  pronoun: string;
  objectPronoun: string;
};

/**
 * Default Adonis identity used as fallback when persona is undefined or missing.
 * This ensures all Adonis-related content displays "Adonis" branding even when
 * the backend fails to provide persona information.
 *
 * `pronoun`/`objectPronoun` are declared as getters (rather than plain string
 * fields resolved once) so each read reflects the currently active i18next
 * locale instead of being frozen to whatever locale was active the first time
 * this module was imported.
 */
export const DEFAULT_ADONIS_IDENTITY: AdonisIdentity = {
  name: "Adonis",
  get pronoun() {
    return i18next.t("adonisIdentity.pronounMale");
  },
  get objectPronoun() {
    return i18next.t("adonisIdentity.objectPronounMale");
  },
};
